import baseapi from "../baseAPI";
import {successMesg, errorMesg, infoMessage, warningMesg} from "./../../Pages/Toaster";

export const DashboardAPI = async (setCampaignsList, setSourceOptionsList, setSourceSeriesList, setUserCount, setCampaignCount, setLeadCount, setConvertedLeadCount, setLoading) =>
{
    setLoading(true);    

    try
    {
        const response = await baseapi.get("/api/admin/dashboard");

        //console.log("Data got successfully", response.data.usercount);
        
        //setUsersList(response.data.data.data);
        setUserCount(response.data.usercount);
        setCampaignCount(response.data.campaigncount);
        setLeadCount(response.data.dashboard.totalcount);
        setConvertedLeadCount(response.data.dashboard.converted);
        setCampaignsList(response.data.campaigns);
        //return response;

        setLoading(false);
    }
    catch(error)
    {
        console.error("Error in user list:", error);

        setLoading(false);
    }

}

export const LeadPerformanceReportAPI = async (setLeadPerformSeries, setLeadPerformOptions, setShowLeadPerformChart, filterparams) =>
{

    setShowLeadPerformChart(true);

    try
    {
        const response = await baseapi.get("api/admin/lead-performance-report" + `?${filterparams.toString()}`);

        //console.log("Data got successfully", response.data);
        
        //setUsersList(response.data.data.data);
        setLeadPerformSeries(response.data.series);
        setLeadPerformOptions(response.data.options);
        
        setShowLeadPerformChart(false);
    }
    catch(error)
    {
        console.error("Error in user list:", error);
        setShowLeadPerformChart(false);
    }
}